import { prop } from 'ramda'

import { PropGetter } from '@surglogs-app/types'

import { ClinicModelEntity } from '../types'

export const getName: PropGetter<ClinicModelEntity, 'institution_name'> =
  prop('institution_name')
